/* projects/speaker-platform/src/app/organisms/history-message/history-message.component.scss */
.history-message-item {
  padding: 8px 6px;
  margin-bottom: 10px;
  margin-top: 8px;
  border-bottom: 1px solid #CCCCCC;
  cursor: pointer;
  font-size: 14px;
}
.history-message-item .name {
  font-size: 16px;
  font-weight: 500;
}
.history-message-item:hover {
  background: #ececec;
}
.history-message-item-selected {
  background: #ececec;
}
/*# sourceMappingURL=history-message.component-WAZ73MSZ.css.map */
